var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42.38,
    height: 42.38,
    viewBox: "0 0 42.38 42.38",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2D4E9D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.463 6.324a4.71 4.71 0 0 0-4.704 4.704 4.71 4.71 0 0 0 4.704 4.704 4.71 4.71 0 0 0 4.705-4.704 4.71 4.71 0 0 0-4.705-4.704zm0 8.316a3.616 3.616 0 0 1-3.611-3.612 3.616 3.616 0 0 1 3.611-3.611 3.616 3.616 0 0 1 3.612 3.611 3.616 3.616 0 0 1-3.612 3.612z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.738 0H3.643A3.647 3.647 0 0 0 0 3.643v35.095a3.647 3.647 0 0 0 3.643 3.642h35.095a3.647 3.647 0 0 0 3.642-3.642V3.643A3.647 3.647 0 0 0 38.738 0zm2.55 38.738a2.553 2.553 0 0 1-2.55 2.55H3.643a2.553 2.553 0 0 1-2.55-2.55v-7.734L14.5 18.113l7.043 6.722 4.936-5.15L41.288 31.04v7.697zm0-9.073L26.369 18.224l-4.86 5.07-7.011-6.693L1.092 29.49V3.643a2.553 2.553 0 0 1 2.55-2.55h35.096a2.553 2.553 0 0 1 2.55 2.55v26.022z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlaceholder);
export default __webpack_public_path__ + "static/media/icon-placeholder.2cce25bedd3fc1557d0ff0227f3d003c.svg";
export { ForwardRef as ReactComponent };